import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "Kreatif",
  icon: "✨",
  templates: [
    {
      title: "Cerita Pengantar Tidur",
      content: `Buat cerita pengantar tidur yang lembut untuk anak kecil, ditulis untuk dibacakan dengan lantang.
- Karakter utama adalah [seekor rubah kecil yang baik hati] bernama [Hazel].
- Cerita berlatar di [sebuah desa hutan yang nyaman di mana lentera bersinar di malam hari].
- Karakter menghadapi tantangan kecil yang menenangkan: [dia tidak bisa menemukan bintang favoritnya di langit berawan, jadi dia mengikuti kunang-kunang ke puncak bukit].
- Akhiri dengan resolusi damai yang mengajarkan [kesabaran dan percaya bahwa hal-hal baik masih ada, bahkan ketika kamu tidak bisa melihatnya].
- Gunakan kalimat pendek dan berirama yang terdengar alami saat dibacakan.`
    },
    {
      title: "Narasi Fiksi Pendek",
      content: `Tulis cerita pendek yang cocok untuk narasi gaya buku audio.
- Genre: [misteri kontemporer].
- Protagonis adalah [seorang pustakawan pensiunan yang menyadari sesuatu yang aneh tentang rutinitas harian tetangga baru].
- Ketegangan utama adalah [detail-detail kecil yang tidak bisa dijelaskan yang membangun menuju pengungkapan yang mengejutkan tapi memuaskan].
- Nada: [ketegangan tenang dengan sentuhan kehangatan].
- Tulis dengan gaya yang jelas dan mengalir dengan variasi panjang kalimat untuk menjaga keterlibatan pendengar.`
    },
    {
      title: "Pembacaan Puisi",
      content: `Tulis puisi yang dimaksudkan untuk dibacakan dengan lantang.
- Topik: [perasaan sebuah kota yang terbangun saat fajar].
- Gaya: [puisi bebas dengan irama bicara alami].
- Suasana: [reflektif dan penuh harapan].
- Sertakan detail sensorik yang hidup: [suara bus pertama, cahaya mengenai trotoar basah, aroma roti segar dari toko roti].
- Gunakan jeda dan pemisahan baris yang memandu ritme dan napas pembaca.`
    }
  ]
};
